export default __webpack_public_path__ + "static/media/search.737e410d.png";